import React, { Suspense, useEffect, useState } from 'react'
import { renderRoutes } from 'react-router-config'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import { LinearProgress } from '@material-ui/core'

import { NavBar, TopBar } from './components'
import { useDispatch, useSelector } from 'react-redux'
import { getAccount, logout } from 'redux/actions'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  topBar: {
    zIndex: 2,
    position: 'relative'
  },
  container: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  navBar: {
    zIndex: 3,
    width: '21.5%',
    minWidth: 256,
    flex: '0 0 auto'
  },
  content: {
    overflowY: 'auto',
    flex: '1 1 auto',
    position: 'relative'
  }
}))

const Dashboard = props => {
  const { route } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const userId = useSelector(state => state.session?.userId)
  const userType = useSelector(state => state.session?.userType)
  const updateAccountTrigger = useSelector(
    state => state.unsaved?.updateAccountTrigger
  )
  const [openNavBarMobile, setOpenNavBarMobile] = useState(false)
  const handleNavBarMobileOpen = () => {
    setOpenNavBarMobile(true)
  }
  const handleNavBarMobileClose = () => {
    setOpenNavBarMobile(false)
  }
  useEffect(() => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    var raw = JSON.stringify({
      userId,
      userType
    })

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(
      'https://www.mytv-plus.net/campaign/api/v1/account/getAccount.php',
      requestOptions
    )
      .then(response => response.json())
      .then(result => {
        if (result?.account?.length === 0) dispatch(logout())
        result.is_success
          ? dispatch(
              getAccount({
                ...result.account?.[0],
                phone:
                  result?.account?.[0]?.companyPhone ||
                  result?.account?.[0]?.phone
              })
            )
          : console.log('error', result)
      })
      .catch(error => console.log('error', error))
    // eslint-disable-next-line
  }, [userId, userType, updateAccountTrigger])
  return (
    <div className={classes.root}>
      <TopBar
        className={classes.topBar}
        onOpenNavBarMobile={handleNavBarMobileOpen}
      />
      <div className={classes.container}>
        <NavBar
          className={classes.navBar}
          onMobileClose={handleNavBarMobileClose}
          openMobile={openNavBarMobile}
        />
        <main id="main" className={classes.content}>
          <Suspense fallback={<LinearProgress />}>
            {renderRoutes(route.routes)}
          </Suspense>
        </main>
      </div>
    </div>
  )
}

Dashboard.propTypes = {
  route: PropTypes.object
}

export default Dashboard
